import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import MonitoringFeedback from "components/Monitoring/MonitoringFeedback";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import { AIBLE_VIEW_TYPE } from "containers/Project/reducer";

class MonitoringFeedbackContainer extends React.Component {
  render() {
    return <MonitoringFeedback {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    adjustAssumptions: () => dispatch(projectReducer.setAibleViewType(ownProps.id, AIBLE_VIEW_TYPE.BUSINESS)),
    deleteUserFeedback: (userId) => dispatch(monitoringReducer.deleteUserFeedback(ownProps.id, userId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const monitor = monitoringReducer.getMonitor(state, ownProps.id);
  const selectedRunId = projectReducer.getRunId(state, ownProps.id);
  return {
    project: projectReducer.getProject(state, ownProps.id),
    modelGroups: projectReducer.getModelGroups(state, ownProps.id),

    monitorViewMode: monitoringReducer.getMonitorViewMode(state, ownProps.id),
    isContinuous: projectReducer.getIsContinuous(state, ownProps.id),
    warnings: monitoringReducer.getMonitorWarnings(state, ownProps.id),
    latestScenario: monitoringReducer.getLatestScenarios(state, ownProps.id),
    latestData: monitoringReducer.getLatestData(state, ownProps.id),
    monitoringData: monitoringReducer.getData(state, ownProps.id),
    segmentId: projectReducer.getSegmentId(state, ownProps.id),
    scenarioIndex: getIsMonitoringDemo() ? projectReducer.getViewingScenarioIndex(state, ownProps.id) : undefined,
    userFeedback: monitoringReducer.getUserFeedback(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MonitoringFeedbackContainer);
